module.exports = __webpack_public_path__ + "static/media/books.0084d93d.svg";